import {ref, reactive} from 'vue';

// State
const visible = ref(false);
const icon = ref('')
const message = ref('');
const isPersistent = ref(false);
const isImportant = ref(false);
const duration = ref(3000);
const count = ref(1);

// Track the current notification
let currentNotification = '';
let dismissTimer = null;
let isImportantNotificationDisplayed = false;

/**
 * Show a notification
 * @param {string} text - Text content of the notification
 * @param {string} icn - String represented svg of icon to display
 * @param {boolean} persistent - Keep notification on screen until explicitly dismissed
 * @param {boolean} important - Overwrite any existing notification
 * @param {boolean} log - Log this notification to console
 * @param {number} notificationDuration - Duration in ms before auto-dismiss (for non-persistent)
 */
export function showNotification(text, icn, persistent = false, important = false, log = true, notificationDuration = 3) {
    persistent = false // override persistent notifications - temporary

    // Handle clear command
    if (text === 'clear') {
        clearNotification();
        return;
    }

    if (log) {
        console.log("Notification:", text, "Important:", important);
    }

    // If an important notification is displayed, only allow overwriting by another important notification
    if (isImportantNotificationDisplayed && !important) {
        console.log("Ignoring non-important notification while an important one is displayed");
        return;
    }

    // Check if this is a repeat of the current notification
    if (text === currentNotification && !important) {
        count.value++;
    } else {
        // New notification
        currentNotification = text;
        count.value = 1;
        icon.value = icn;
        message.value = text;
        isPersistent.value = persistent;
        isImportant.value = important;
        duration.value = notificationDuration * 1000;

        // Show the notification if not already visible
        if (!visible.value) {
            visible.value = true;
        }
    }

    isImportantNotificationDisplayed = important;

    // Set up auto-dismiss for non-persistent notifications
    if (!persistent) {
        clearTimeout(dismissTimer);
        dismissTimer = setTimeout(() => {
            dismissNotification();
        }, notificationDuration * 1000);
    }
}

/**
 * Dismiss the current notification
 */
export function dismissNotification() {
    clearTimeout(dismissTimer);
    visible.value = false;
    currentNotification = '';
    count.value = 1;
    isImportantNotificationDisplayed = false;
}

/**
 * Clear the current notification
 */
function clearNotification() {
    dismissNotification();
}

// Export state and functions
export const notificationState = {
    visible,
    icon,
    message,
    isPersistent,
    isImportant,
    duration,
    count,
    dismiss: dismissNotification
};